import axios from 'axios';
import ManageStorage from "../../shared/global/manageStorage";
import ServiceAuth from '../auth/authToken';

const emailApiConfig = axios.create({
    baseURL: process.env.REACT_APP_API_EMAIL,
});

emailApiConfig.interceptors.request.use(
    async config => {
        config.headers = {
            'Authorization': `Bearer ${ManageStorage.getValueFromStorage("token")}`,
        }
        return config;
    },
    error => {
        Promise.reject(error)
    });

    emailApiConfig.interceptors.response.use((response) => {
    return response
}, async function (error) {
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        const { data } = await ServiceAuth.authUserGuest({
            username: process.env.REACT_APP_USER_GUEST
        });
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.accessToken;
        ManageStorage.setItemStorage("token", data.accessToken);
        return emailApiConfig(originalRequest);
    }
    return Promise.reject(error);
});

export default emailApiConfig;